import { render, staticRenderFns } from "./DefinedTipsRepeater.vue?vue&type=template&id=62b63d72&scoped=true&"
import script from "./DefinedTipsRepeater.vue?vue&type=script&lang=js&"
export * from "./DefinedTipsRepeater.vue?vue&type=script&lang=js&"
import style0 from "./DefinedTipsRepeater.vue?vue&type=style&index=0&id=62b63d72&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62b63d72",
  null
  
)

export default component.exports